import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchDrawingTool, SketchSplineCommand } from '@puppycad/cad-core';
import StyleSplinePropertySection from '@/components/editor/property-manager/style-spline/StyleSplinePropertySection.vue';

registerPropertyManagerSection({
  id: SketchSplineCommand.StyleSpline,
  title: (context) => {
    const isToolActive = context.drawingTool === SketchDrawingTool.StyleSpline;
    const hasSelection = context.styleSplinePropertyVisible === true;
    const pointCount = context.drawingPointCount ?? 0;
    if (isToolActive && pointCount === 0 && !hasSelection) {
      return '\u63d2\u5165\u6837\u5f0f\u6837\u6761\u66f2\u7ebf';
    }
    return '\u6837\u5f0f\u6837\u6761\u66f2\u7ebf';
  },
  order: 14,
  component: StyleSplinePropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.styleSplinePropertyVisible === true),
});
